import { Box, Typography, TextField, IconButton, FormHelperText, FormControlLabel, Switch } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export function ListNodeFields({
                                 localNodeData,
                                 updateNodeData,
                                 options,
                                 error,
                                 handleOptionChange,
                                 deleteOption,
                                 addOption
                               }) {
  const AdvanceResponse = localNodeData.AdvanceResponse || false;

  return (
      <>
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
            Contenido del Mensaje
          </Typography>
          <TextField
              value={localNodeData.bodyText || ''}
              size="small"
              fullWidth
              multiline
              minRows={3}
              // permite que el usuario cambie el alto del área de texto
              sx={{
                '& .MuiInputBase-root': {
                  alignItems: 'flex-start'
                },
                '& textarea': {
                  resize: 'vertical', // usuario puede agrandar/achicar verticalmente
                  overflow: 'auto'
                }
              }}
              onChange={(e) => updateNodeData('bodyText', e.target.value)}
          />
        </Box>

        <Box>
          <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
            Texto de subtitulo
          </Typography>
          <TextField
              value={localNodeData.footerText || ''}
              size="small"
              fullWidth
              multiline
              rows={2}               // menos alto que antes
              sx={{
                '& .MuiInputBase-input': {
                  fontSize: '0.8rem'  // texto más pequeño
                }
              }}
              onChange={(e) => updateNodeData('footerText', e.target.value)}
          />
        </Box>

        {/* Configuración para almacenar respuesta, igual que en MessageNodeFields */}
        <Box sx={{ mt: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Respuesta esperada
            </Typography>
            <FormControlLabel
              sx={{ m: 0 }}
              control={
                <Switch
                  size="small"
                  checked={AdvanceResponse}
                  onChange={(e) => updateNodeData('AdvanceResponse', e.target.checked)}
                />
              }
              label="Almacenar respuesta"
            />
          </Box>

          {/* MODO SIMPLE: sólo descripción/ayuda opcional para la respuesta */}
          {!AdvanceResponse && (
            <TextField
              value={localNodeData.expected || ''}
              size="small"
              fullWidth
              multiline
              rows={2}
              placeholder="Describe brevemente qué esperas que el usuario responda"
              onChange={(e) => updateNodeData('expected', e.target.value)}
            />
          )}

          {/* MODO AVANZADO: separar en output_key y descripción/esperado */}
          {AdvanceResponse && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <TextField
                label="output_key"
                placeholder="Ej: opcion_seleccionada"
                value={localNodeData.OutputKey || ''}
                size="small"
                fullWidth
                onChange={(e) => updateNodeData('OutputKey', e.target.value)}
              />
              <TextField
                label="Formato / valor esperado"
                placeholder="Ej: opción elegida por el usuario"
                value={localNodeData.expected || ''}
                size="small"
                fullWidth
                multiline
                rows={2}
                onChange={(e) => updateNodeData('expected', e.target.value)}
              />
            </Box>
          )}
        </Box>

        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
            Opciones de lista
          </Typography>
          {options.map((option) => (
              <div key={option.id}>
                <Box
                    sx={{ display: 'flex', gap: 1, mb: 1, alignItems: 'center' }}
                >
                  <TextField
                      value={option.title}
                      size="small"
                      fullWidth
                      placeholder="Escribe una opción"
                      onChange={(e) => handleOptionChange(option.id, e.target.value, 'list')}
                      error={!!error[option.id]}
                  />
                  <IconButton
                      size="small"
                      onClick={() => deleteOption(option.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
                {error[option.id] && (
                    <FormHelperText error>{error[option.id]}</FormHelperText>
                )}
              </div>
          ))}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton onClick={addOption} size="small">
              <Typography variant="body2" color="primary">
                + Agregar Opción
              </Typography>
            </IconButton>
          </Box>
        </Box>
      </>
  );
}
